

















import { Page } from '@/core/components/controls';
import { Component, Prop } from 'vue-property-decorator';
import { latLng, LatLng } from 'leaflet';
import { getTableCaption } from '@/core/components/table';
import { RelocationsMapPageArgs } from './types';
import Map from '@/core/components/map';
import { MapMarker } from '@/dto';

@Component({
    components: {
        Map
    },
})
export default class RelocationsMapPage extends Page {
    @Prop({ default: () => ({}) }) public args!: RelocationsMapPageArgs;
    public channels: any[] = [];
    public center: LatLng = latLng(0, 0);

    public vehicleMarkers: MapMarker[] = [];
    public siteMarkers: MapMarker[] = [];

    public get pageName(): string {
        return getTableCaption('relocations-map-page');
    }

    public async mounted() {
        const _center = { count: 0, sumLatitude: 0, sumLongitude: 0 };

        this.args.relocationsMapItems?.forEach((v) => {
            _center.count += 2;
            _center.sumLatitude += v.destination.latitude + v.source.latitude;
            _center.sumLongitude += v.destination.longitude + v.source.longitude;

            // Save coordinates of sites
            [v.destination, v.source].forEach((site) => {
                const siteCoords = latLng(+site.latitude.toFixed(6), +site.longitude.toFixed(6));
                this.addSiteMarker(siteCoords, site.name);
            });

            // Add channel
            const channel = [
                [v.source.latitude.toFixed(6), v.source.longitude.toFixed(6)],
                [v.destination.latitude.toFixed(6), v.destination.longitude.toFixed(6)]
            ];
            const marker = this.channels.find(
                x => (x[0].toString() === channel[0].toString() && x[1].toString() === channel[1].toString()) ||
                    (x[0].toString() === channel[1].toString() && x[1].toString() === channel[0].toString())
            );
            if (marker === undefined) {
                this.channels.push(channel);
            }

            // Get vehicle coordinate
            if (v.vehicle.latitude && v.vehicle.longitude) {
                const vehicleCoords = latLng(+v.vehicle.latitude.toFixed(6), + v.vehicle.longitude.toFixed(6));
                this.addVehicleMarker(vehicleCoords, v.vehicle);
            }
        });

        this.center = latLng(_center.sumLatitude / _center.count, _center.sumLongitude / _center.count);
    }

    public addVehicleMarker(coords: LatLng, markerInfo: any) {
        const marker = this.vehicleMarkers.find(x => x.latLng.lat === coords.lat && x.latLng.lng === coords.lng);
        if (marker === undefined) {
            this.vehicleMarkers.push({
                latLng: coords,
                info: {
                    type: markerInfo.icon,
                    name: [ markerInfo.name ]
                }
            });
        } else {
            const info = marker?.info.name || [];
            if (info.indexOf(markerInfo.name) === -1) {
                info.push(markerInfo.name);
            }
        }
    }

    public addSiteMarker(coords: LatLng, markerInfo: any) {
        const marker = this.siteMarkers.find(x => x.latLng.lat === coords.lat && x.latLng.lng === coords.lng);
        if (marker === undefined) {
            this.siteMarkers.push({
                latLng: coords,
                info: [markerInfo]
            });
        } else {
            const info = marker?.info || [];
            if (info.indexOf(markerInfo) === -1) {
                info.push(markerInfo);
            }
        }
    }
}
